<template lang="pug">
.content.exercise-add-content
  .row.exercise-add-body
    .col-md-12.col-md-header
      .header Thêm mới bài tập
    .col-md-12(v-if="error")
      .form-group(style="margin: 0;")
        .alert.alert-danger(style="margin: 0;") {{error}}
    .col-md-12.col-md-name
      .form-group
        label.control-label Tên bài tập *
        input#name.form-control(type='text', placeholder="Nhập tên bài tập" required v-model="nameExercise" maxlength=255)
    .col-md-6.categ-question
      .form-group
        label.control-label Chọn môn học *
        select#subject-id.form-control(@change="onChangeSelect($event, 'subject')" required)
          option(v-for='o in subjects' :value='o.id' :selected="o.id === subjectID") {{o.name}}
    .col-md-6.lv-question.col-grade-id
      .form-group
        label.control-label Chọn khối lớp *
        Select2#grade_id(v-model="gradeID" :options="grades" :settings="settingGrades")
    //- .col-md-6
    //-   select2Grade(:data="grades" title="Chọn" :setting="settingGrades")
    .clearfix
    .col-md-6.categ-question
      .form-group
        label.control-label Danh mục bài tập *
        select#categ-id.form-control(@change="onChangeSelect($event, 'category')" required)
          option(v-for='o in categExercise' :value='o.id') {{o.name}}
    .col-md-6.lv-question
      .form-group
        label.control-label Loại bài tập *
        select#type-id.form-control(@change="onChangeSelect($event, 'type-exercise')" required)
          option(v-for='o in lstTypeTest' :value='o.key' :selected="o.key === typeExercise") {{o.name}}
    .clearfix
    .col-md-6.categ-question
      .form-group
        label.control-label Cấp độ bài tập *
        select#level.form-control(@change="onChangeSelect($event, 'level')" required)
          option(v-for='o in lstLevel' :value='o.key') {{o.value}}
      .clearfix
    .col-md-12.list-questions
      .title DANH SÁCH CÂU HỎI
      .card.card-question
        .card-content.card-content-question
          .row
            .col-md-6.col-xs-6.categ-question
              .form-group
                label.control-label Danh mục câu hỏi
                select#categ-question-id.form-control(@change="onFilterQuestion($event, 'category')" required)
                  option(value='0' selected) Chọn danh mục câu hỏi
                  option(v-for='o in categQuestion' :value='o.id') {{o.name}}
            .col-md-6.col-xs-6.lv-question
              .form-group
                label.control-label Cấp độ câu hỏi
                select#lv-question.form-control(@change="onFilterQuestion($event, 'level')" required)
                  option(value='0' selected) Chọn cấp độ câu hỏi
                  option(v-for='o in lstLevel' :value='o.key') {{o.value}}
            .clearfix
            .col-md-9.col-xs-7.categ-question
              .form-group
                label.control-label Chọn câu hỏi *
                //- select#questions.form-control(@change="onFilterQuestion($event, 'question')" required)
                //-   option(value='0' selected) Chọn câu hỏi
                //-   option(v-for='o in questions' :value='o.id') {{o.customName}}
                Select2#lstQuestions(:options="questions" :settings="settingQuestions" @select="onFilterQuestion($event, 'question')" :key="force")
            .col-md-3.col-xs-5.lv-question
              .box-btn-question-search
                button.btn.btn-question-search(@click="addQuestion") Thêm câu hỏi
        .line
        .card-content.card-table-question
          //- span THE QUESTIONS ARE BUILDING
          .box-table-question(v-on:scroll.passive='handleScroll' v-if="!$isMobile()")
            tbQuestion(
              @onfilterbyname="filterbyname",
              @onItemDelete="onQuestionFormDelete",
              @onItemEdit="onQuestionFormEdit",
              @onItemView="onQuestionFormView",
              @onFilterBlue="filterBlue",
              @pageChange="onPageChange",
              :keyword="filtername",
              :lstLevel='lstLevel',
              :lstFilter='lstFilter'
              :data='lstCurrQuestion',
              :offset="offset"
              :limit="limit"
              :columns='columns',
              :config="config"
              :inlineFilter='true' 
              :key="force")

          .card-lst-question(v-else)
            .row-header
              span.label-header Câu hỏi
              .field-header
                input(@change="filterbyname($event.target.value)" placeholder="Tìm theo nội dung câu hỏi lớn")
            .clearfix
            .list-item(v-if='lstCurrQuestion.length > 0')
              .row-item(v-for='(item, index) in lstCurrQuestion')
                .row-data
                  .board-info
                    span {{item.content_plain_text}}
                .row-data
                  .filter-item
                    span(:id="'categ_' + item.category_question.id" 
                      @click="filterItems(item.category_question.id, 1)"
                      :class="lstFilter.categories.includes(item.category_question.id) ? 'checked' : ''"
                    ) {{item.category_question.name}}
                    span(:id="'lv_' + item.level" 
                      @click="filterItems(item.level, 2)"
                      :class="lstFilter.level.includes(item.level) ? 'checked' : ''"
                    ) {{getDataValue(item.level, 1)}}
                    span(v-for="g in item.question_grade" 
                      :id="'grade_' + g.grade.id" 
                      @click="filterItems(g.grade.id, 3)"
                      :class="lstFilter.grades.includes(g.grade.id) ? 'checked' : ''"
                    ) {{g.grade.name}}
                .row-data
                  .action-buttons
                    span.list-action
                      small(@click="onQuestionFormEdit(item)")
                        img(:src="require('../../assets/images/faces/ic_edit.svg')")
                    span.list-action
                      small(@click="onQuestionFormDelete(item)")
                        img(:src="require('../../assets/images/theory/delete-24px.svg')")
                    span.list-action
                      small.support
                        .fas.fa-eye(style="color:#333333;margin-top: 9px;" @click="onQuestionFormView(item)")
            .clearfix
            Pagination(v-if="lstCurrQuestion.length > 0"
              :screenExercise="true"
              :currentPage="config.currentPage"
              :pageRange="config.pageRange"
              :itemsPerPage="config.itemsPerPage"
              :totalItems="config.totalItems"
              @pageChange="onPageChange"
            )
        .clearfix
      .clearfix
    .col-md-6.total-time
      .form-group
        label.control-label Tổng thời gian làm bài tập (phút) *
        //- input#time.without_ampm.form-control(type='time' required :value="time")
        input#time.form-control(type="number" placeholder="Nhập" min="0" step="1" v-model="time")
      .clearfix
    .col-md-12.col-checkbox
      .box-save
        .title.box-item-footer(:style="$isMobile() ? 'top: 0' : ''") LƯU BÀI TẬP
        .clearfix(v-if="$isMobile()")
        .box-item-footer
          .item-checkbox
            input(type="checkbox" 
              name="cb_question" 
              id="cb_question"  
              @click="onCheckSave($event, 3)")
            label(for="cb_question")
            span Lưu lại và chỉnh sửa sau
        .card.card-save
          .card-content.card-content-save
            div(:class="is_save_edit ? 'opacity' : ''")
            .item-checkbox
              input(type="checkbox" name="public_all" id="public_all" :checked="is_public === 2" disabled)
              label(for="public_all")
              span Lưu bài tập và cho phép học sinh trong toàn hệ thống tìm kiếm được để mua đáp án
            .clearfix
            .item-checkbox
              input(type="checkbox" name="public_pc" id="public_pc"  @click="onCheckSave($event, 2)")
              label(for="public_pc")
              span Lưu bài tập riêng tư (chỉ cho hiển thị trong cộng đồng và lớp học của tôi)
            .box-left(v-if="is_public_pc > 1")
              .row.row-amount-honey
                .col-md-6
                  .form-group
                    label.control-label Số hũ mật ong để xem đáp án *
                    input#amount_honey.form-control(type='text', placeholder="Nhập số hũ mật ong" required v-model="amountHoney" @keypress="checkNumber")
              .row.row-share-class
                .col-md-6
                  .form-group
                    select#class_id.form-control(@change="onChangeSelect($event, 'class')" required)
                      option(value='0' selected disabled) Chọn lớp học bạn muốn chia sẻ trong PC
                      option(v-for='o in classes' :value='o.id' :data-exercises="o.exercise_ids") {{o.name}}
              .row.row-class
                .col-md-12
                  .box-item-attach(v-if="item" v-for="(item, index) in lstClassAdded")
                    label
                      img(src="../../assets/images/theory/ic_class.png")
                      span {{item.name}}
                      span.material-icons.remove(@click='deleteClass(index)' style='cursor: pointer;') delete

      .button-handle
        button(class="btn btn-active" @click="validateSave(1)") Thêm mới
        button(type="reset" class="btn btn-rest" @click="validateSave(2)") Huỷ yêu cầu

</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import Select2 from 'v-select2-component'
import jQuery from 'jquery'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
import tbQuestion from './tbQuestion'
import Pagination from '../Front/Pagination'
export default {
  components: {Select2, jQuery, MdNotification, moment, tbQuestion, Pagination},
  data() {
    return {
      error: '',
      nameExercise: '',
      subjects: [],
      subjectID: 9,
      grades: [],
      gradeID: null,
      categExercise: [],
      categoryID: null,
      categQuestion: [],
      classes: [],
      lstClassAdded: [],
      time: '',
      amountHoney: '',
      is_save_edit: false,
      is_public: 2, // 1. ko public 2.public
      is_public_pc: 1, // 1. ko public 2.public cho PC
      filter: '{is_delete: {_eq: false}, created_by: {_eq: "' + this.$store.getters.user + '"}',
      lstLevel: [
        {key: 1, value: 'Sơ cấp'},
        {key: 2, value: 'Trung cấp'},
        {key: 3, value: 'Cao cấp'}
      ],
      level: 1,
      lstTypeTest: [
        {key: 1, name: 'Quiz random'},
        {key: 2, name: 'Bài tập thi đấu'},
        {key: 3, name: 'Khóa học'},
        {key: 4, name: 'Bài tập chung'}
      ],
      typeExercise: 4, // default 4.Bai tap chung
      settingGrades: {
        multiple: true,
        closeOnSelect: true,
        allowClear: true,
        placeholder: 'Chọn',
        escapeMarkup: this.buildInpuGrades,
        templateResult: this.formatFilterGrades,
        containerCssClass: 'custom-container-exgrades',
        dropdownCssClass: 'custom-dropdown-exgrades'
      },
      settingQuestions: {
        escapeMarkup: this.buildInputQuestions,
        templateResult: this.formatFilterQuestions,
        matcher: this.matchCustom,
        containerCssClass: 'custom-container-exquestions',
        dropdownCssClass: 'custom-dropdown-exquestions'
      },
      force: 0,
      questions: [],
      columns: [
        { key: 'stt', title: 'STT' },
        { key: 'name', title: 'Tên câu hỏi', type: 'name' },
        { key: 'action', title: '', type: 'action' }
      ],
      lstQuestionAdded: [],
      lstOldQuestionAdded: [],
      lstCurrQuestion: [],
      filtername: '',
      filtersubject: null,
      lstFilter: {
        categories: [],
        level: [],
        grades: []
      },
      countGrades: 0,
      parentFilter: {
        categories: [],
        level: []
      },
      selectedQuestion: null,
      limit: 5,
      offset: 0,
      config: {
        currentPage: 1,
        pageRange: 3,
        totalItems: 0,
        itemsPerPage: 5 // limit
      },
      orderBy: '{id: desc}'
    }
  },
  methods: {
    forceUpdate() {
      this.force++
    },
    checkNumber(evt) {
      evt = evt || window.event
      let charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // Hiện loading...
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        canCancel: false
      })
    },
    buildInpuGrades(item) {
      let html = jQuery(
        '<style>' +
          '.select2-container--default .select2-selection--multiple .select2-selection__rendered {padding: 6px 15px;}' +
          '.select2-container--default .select2-selection--multiple {border-radius: 10px; min-height: 48px;}' +
          '.select2-container--default .select2-selection--multiple .select2-selection__clear {margin-right: 0px;}' +
        '</style>' +
        '<span class="placeholder">' + item + '</span>'
      )
      return html
    },
    formatFilterGrades(item) {
      let html = jQuery(
        '<style>' +
          '.select2-results {text-align: left;}' +
        '</style>' +
        '<div class="item-filter-info"><span>' + item.name + '</span></div>'
      )
      return html
    },
    buildInputQuestions() {
      let html = jQuery(
        '<style>' +
          '.select2-container .select2-selection--single{border-radius:10px !important;height:48px !important;}' +
          '.select2-container .select2-selection--single .select2-selection__rendered {padding-left: 15px; padding-right: 15px; line-height: 48px; text-align: left;}' +
          '.select2-container--default .select2-selection--single .select2-selection__arrow {height: 48px;}' +
          '.select2-selection__rendered span{color: #000000;}' +
          '.select2-selection__rendered span.results-message{display:none;}' +
        '</style>' +
        '<span class="placeholder">' + (this.selectedQuestion !== null && this.selectedQuestion.customName || 'Chọn câu hỏi') + '</span>' +
        '<span class="results-message">Không có dữ liệu</span>'
        )
      return html
    },
    formatFilterQuestions(item) {
      let html = jQuery(
        '<style>' +
          '.select2-results {text-align: left;}' +
          '.select2-results__option {display: block; max-height: 52px; overflow: hidden;}' +
        '</style>' +
        '<div class="item-filter">' +
          '<div class="item-filter-info"><span>' + item.customName + '</span></div>' +
        '</div>')
      return html
    },
    matchCustom(params, data) {
      if (jQuery.trim(params.term) === '') {
        return data
      }
      if (typeof data.customName === 'undefined') {
        return null
      }
      if (data.customName.trim().toLowerCase().indexOf(params.term.trim().toLowerCase()) > -1) {
        var modifiedData = jQuery.extend({}, data, true)
        return modifiedData
      }
      return null
    },
    // Xóa lớp đã chọn
    deleteClass(index) {
      this.classes.push(this.lstClassAdded[index])
      this.lstClassAdded.splice(index, 1)
    },
    // Hiện thông báo
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    getDataValue(key, type) {
      if (type === 1) {
        for (let i = 0; i < this.lstLevel.length; i++) {
          if (this.lstLevel[i].key === key) return this.lstLevel[i].value
        }
      }
    },
    // onChange những selection trong bài tập
    onChangeSelect(e, type) {
      if (type === 'category') {
        this.categoryID = parseInt(e.target.value)
      } else if (type === 'level') {
        this.level = parseInt(e.target.value)
      } else if (type === 'subject') {
        this.subjectID = parseInt(e.target.value)
        if (this.is_public_pc === 2) this.refetchClass()
        // refresh danh sách câu hỏi trong dropdown
        this.filtersubject = parseInt(e.target.value)
        this.$apollo.queries.questions.refetch()
      } else if (type === 'type-exercise') {
        this.typeExercise = parseInt(e.target.value)
      } else if (type === 'class') {
        let obj = {'name': e.target.options[e.target.options.selectedIndex].innerText, 'id': e.target.value}
        let exercises = e.target.options[e.target.options.selectedIndex].getAttribute('data-exercises')
        if (exercises !== null) {
          // console.log(exercises.split(','), typeof exercises)
          obj = Object.assign(obj, {exercise_ids: exercises.split(',')})
        } else {
          obj = Object.assign(obj, {exercise_ids: null})
        }
        this.lstClassAdded.push(obj)
        this.classes.splice(this.classes.findIndex(({name}) => name === e.target.options[e.target.options.selectedIndex].innerText), 1)
        jQuery('#class_id').val(0)
      }
    },
    // onChange điều kiện để lấy danh sách câu hỏi dropdown
    onFilterQuestion(e, type) {
      let valueEvent = (type !== 'question') && parseInt(e.target.value)
      if (type === 'category') {
        this.parentFilter.categories = []
        if (valueEvent > 0) this.parentFilter.categories.push(valueEvent)
        else this.parentFilter.categories = []
        this.$apollo.queries.questions.refetch()
      } else if (type === 'level') {
        this.parentFilter.level = []
        if (valueEvent > 0) this.parentFilter.level.push(valueEvent)
        else this.parentFilter.level = []
        this.$apollo.queries.questions.refetch()
      } else if (type === 'question') {
        // Xử lý thường
        // this.selectedQuestion = this.questions.filter(key => key.id === parseInt(e.target.value))[0]
        // Xử lý select2
        this.selectedQuestion = this.questions.filter(key => key.id === parseInt(e.id))[0]
        this.forceUpdate()
      }
    },
    // Lọc câu hỏi kanban
    filterItems(id, type) {
      if (type === 1) {
        if (!this.lstFilter.categories.includes(id)) {
          this.lstFilter.categories.push(id)
        } else {
          this.lstFilter.categories.splice(this.lstFilter.categories.indexOf(id), 1)
        }
      } else if (type === 2) {
        if (!this.lstFilter.level.includes(id)) {
          this.lstFilter.level.push(id)
        } else {
          this.lstFilter.level.splice(this.lstFilter.level.indexOf(id), 1)
        }
      } else if (type === 3) {
        if (!this.lstFilter.grades.includes(id)) {
          this.lstFilter.grades.push(id)
        } else {
          this.lstFilter.grades.splice(this.lstFilter.grades.indexOf(id), 1)
        }
      }
      this.filterBlue(this.lstFilter)
    },
    // Lọc câu hỏi theo danh mục, cấp độ, khối lớp(1)
    filterBlue(payload) {
      // console.log(payload)
      this.lstFilter.categories = payload.categories
      this.lstFilter.level = payload.level
      this.lstFilter.grades = payload.grades
      this.filterSummary(this.filtername, payload.categories, payload.level, payload.grades)
    },
    // Lọc câu hỏi theo tên tìm kiếm(2)
    filterbyname(valueName) {
      // console.log(valueName)
      this.filtername = valueName
      this.filterSummary(valueName, this.lstFilter.categories, this.lstFilter.level, this.lstFilter.grades)
    },
    // Lọc tổng hợp theo điều kiện(1) + (2)
    filterSummary(keyword, categories, levels, grades) {
      // console.log(keyword, this.lstQuestionAdded)
      if (keyword !== '') {
        this.lstQuestionAdded = this.lstQuestionAdded.filter(s => s.content_plain_text.trim().toLowerCase().includes(keyword.trim().toLowerCase()))
      } else {
        // console.log('1')
        if (grades.length === 0) {
          // console.log('111')
          this.lstQuestionAdded = this.lstOldQuestionAdded
        }
      }
      if (categories !== null && categories !== undefined && categories.length > 0) {
        // console.log('2')
        if (keyword === '') this.lstQuestionAdded = this.lstOldQuestionAdded
        this.lstQuestionAdded = this.lstQuestionAdded.filter(c => categories.includes(c.categ_id))
      }
      if (levels !== null && levels !== undefined && levels.length > 0) {
        // console.log('3')
        if (keyword === '') this.lstQuestionAdded = this.lstOldQuestionAdded
        this.lstQuestionAdded = this.lstQuestionAdded.filter(c => levels.includes(c.level))
      }
      if (grades !== null && grades !== undefined && grades.length > 0) {
        // console.log('4')
        if (keyword === '') this.lstQuestionAdded = this.lstOldQuestionAdded
        let filterLast = []
        for (let i = 0; i < this.lstQuestionAdded.length; i++) {
          let gradeIDs = this.lstQuestionAdded[i].grade_ids
          // console.log(grades, gradeIDs, gradeIDs.length - grades.length)
          let intersection = gradeIDs.filter(x => grades.includes(x))
          if (intersection.length > 0 && (gradeIDs.length - grades.length) >= 0) {
            filterLast[filterLast.length] = this.lstQuestionAdded[i]
            // console.log('+++', filterLast)
            let lstGradeNotIn = gradeIDs.filter(y => !grades.includes(y))
            if (lstGradeNotIn.length > 0 && grades.length > 1) {
              // filterLast = filterLast.filter(o => !check.includes(o.id))
              // TODO:
              // lấy phần tử nào có khối lớp thuộc grades (đã chọn)
            }
          }
        }
        this.lstQuestionAdded = [...filterLast]
      }
      this.handlePageChange()
      this.forceUpdate()
      // console.log(this.lstQuestionAdded)
    },
    // Chỉnh sửa câu hỏi đã chọn
    onQuestionFormEdit(payload) {
      // console.log(payload)
      let route = this.$router.resolve({name: 'question_edit', params: { id: payload.id }})
      window.open(route.href, '_blank')
    },
    // Xem câu hỏi đã chọn
    onQuestionFormView(payload) {
      // console.log(payload)
      let route = this.$router.resolve({name: 'question_edit', params: { id: payload.id }, query: {review: true}})
      window.open(route.href, '_blank')
    },
    // Xóa câu hỏi đã chọn
    onQuestionFormDelete(payload) {
      // console.log(payload)
      let indexSelected = this.lstQuestionAdded.findIndex(k => k.id === payload.id)
      this.lstQuestionAdded.splice(indexSelected, 1)
      this.lstOldQuestionAdded = this.lstQuestionAdded // clone lại danh sách mới nhất
      this.handlePageChange()
      this.time = 0
      let totalTime = 0
      for (let i = 0; i < this.lstOldQuestionAdded.length; i++) {
        totalTime += this.lstOldQuestionAdded[i].time
      }
      this.time += Math.round(totalTime / 60)
      this.forceUpdate()
    },
    // Lấy danh sách lớp khi tick share bài tập vào lớp
    async refetchClass() {
      this.classes = []
      this.lstClassAdded = []
      await this.$apollo.query({
        query: gql(graphql.GET_CLASSES_WITH_SUBJECT),
        fetchPolicy: 'no-cache',
        variables: {
          user_id: this.$store.getters.user,
          subject_id: this.subjectID,
          order_by: {id: 'asc'}
        }
      }).then((res) => {
        this.classes = res.data.classes
        // console.log(res.data.classes)
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
    },
    // Xử lý các ô checkbox
    onCheckSave(e, type) {
      if (type === 1) {
        // if (e.target.checked) this.is_public = 2
        // else this.is_public = 1
      } else if (type === 2) {
        if (e.target.checked) {
          this.is_public_pc = 2
          if (this.subjectID !== null && this.subjectID !== '') this.refetchClass()
          // Tính tổng số lượng mật ong trong câu hỏi đã chọn
          if (this.lstOldQuestionAdded.length > 0) {
            this.amountHoney = 0
            for (let i = 0; i < this.lstOldQuestionAdded.length; i++) {
              this.amountHoney += this.lstOldQuestionAdded[i].amount_honey
            }
          } else {
            this.amountHoney = ''
          }
        } else {
          this.is_public_pc = 1
          this.amountHoney = 0
        }
      } else {
        this.is_save_edit = e.target.checked
      }
    },
    onPageChange(payload) {
      // console.log(payload)
      this.config.currentPage = payload
      this.handlePageChange()
    },
    handlePageChange() {
      this.config.totalItems = this.lstQuestionAdded.length
      this.lstCurrQuestion = []
      this.offset = (this.config.currentPage - 1) * this.limit
      // console.log(this.offset, this.limit)
      for (let i = this.offset; i < this.offset + this.limit; i++) {
        if (this.lstQuestionAdded[i] !== undefined && this.lstQuestionAdded[i] !== null) {
          this.lstCurrQuestion.push(this.lstQuestionAdded[i])
        }
      }
      this.forceUpdate()
      // console.log(this.lstCurrQuestion)
    },
    // Thêm câu hỏi
    addQuestion() {
      if (this.selectedQuestion) {
        if (this.lstQuestionAdded.filter(key => key.id === this.selectedQuestion.id).length === 0) {
          this.lstQuestionAdded.unshift(this.selectedQuestion)
          this.lstOldQuestionAdded = this.lstQuestionAdded // clone lại danh sách mới nhất
          this.handlePageChange() // xu ly phan trang
          let totalTime = 0
          for (let i = 0; i < this.lstQuestionAdded.length; i++) {
            totalTime += this.lstQuestionAdded[i].time
          }
          this.time = Math.round(totalTime / 60)
          this.selectedQuestion = null
          jQuery('#questions').val(0)
          this.forceUpdate()
        } else {
          this.showNotification('Câu hỏi này đã được thêm rồi', 'warning', 'top', 'right', 5000)
          this.error = 'Câu hỏi này đã được thêm rồi.'
        }
      } else {
        this.showNotification('Vui lòng chọn câu hỏi', 'warning', 'top', 'right', 5000)
      }
    },
    // Kiểm tra các ô required trước khi validate
    checkForm() {
      if (this.nameExercise === null || this.nameExercise === '') {
        this.showNotification('Vui lòng nhập tên bài tập', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng nhập tên bài tập.'
        return false
      } else if (this.categExercise === null || this.categExercise.length === 0) {
        this.showNotification('Vui lòng tạo danh mục bài tập', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng tạo Danh mục bài tập.'
        return false
      } else if (this.subjects === null || this.subjects.length === 0) {
        this.showNotification('Vui lòng tạo môn học', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng tạo Môn học.'
        return false
      } else if (this.grades === null || this.grades.length === 0) {
        this.showNotification('Vui lòng tạo khối lớp', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng tạo Khối lớp.'
        return false
      } else if (this.gradeID === null || this.gradeID.length === 0) {
        this.showNotification('Vui lòng chọn khối lớp', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng chọn Khối lớp.'
        return false
      } else if (this.lstQuestionAdded.length === 0) {
        this.showNotification('Vui lòng Thêm câu hỏi cho bài tập', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng Thêm câu hỏi cho bài tập.'
        return false
      } else if (this.time < 1 || this.time === '' || this.time.toString().indexOf('.') !== -1) {
        this.showNotification('Vui lòng nhập tổng thời gian làm bài tập lớn hơn 0 và là số nguyên dương', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng nhập tổng thời gian làm bài tập lớn hơn 0 và là số nguyên dương.'
        return false
      } else {
        if (!this.is_save_edit && this.is_public_pc === 2) {
          if (this.lstClassAdded.length === 0) {
            this.showNotification('Vui lòng Thêm lớp cần chia sẻ bài tập', 'warning', 'top', 'right', 5000)
            this.error = 'Vui lòng Thêm lớp cần chia sẻ bài tập.'
            return false
          }
        }
        this.error = ''
        return true
      }
    },
    // Validate bài tập
    validateSave(type) {
      if (type === 1) {
        if (!this.checkForm()) {
          return
        }
        this.show()
        let insertData = {
          categ_id: this.categoryID !== null ? parseInt(this.categoryID) : parseInt(this.categExercise[0].id),
          subject_id: this.subjectID !== null ? parseInt(this.subjectID) : parseInt(this.subjects[0].id),
          level: this.level,
          name: this.nameExercise,
          created_by: this.$store.getters.user,
          updated_by: this.$store.getters.user,
          type_test: this.typeExercise,
          is_public: this.is_public,
          time: parseInt(this.time) * 60,
          is_public_pc: this.is_public_pc,
          is_complete: !this.is_save_edit
        }
        if (!this.is_save_edit && this.is_public_pc === 2) {
          insertData = Object.assign(insertData, {amount_honey: this.amountHoney})
        }
        let variables = {exercise: [insertData]}
        // console.log(variables)
        this.$apollo.mutate({
          mutation: gql(graphql.CREATE_EXERCISE),
          variables: variables,
          update: (store, { data: { insert_exercise } }) => {
            if (insert_exercise.affected_rows) {
              let returning = insert_exercise.returning[0]
              console.log('CREATE_EXERCISE: ', returning)
              this.createQuestionExercise(returning.id)
              if (this.is_public_pc === 1) this.createExerciseGrade(returning.id, true)
              else this.createExerciseGrade(returning.id)
              if (this.is_public_pc === 2) this.createExerciseUser(returning.id)
            }
          }
        }).catch((error) => {
          this.loader.hide()
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0)
          }
          this.showNotification(error, 'warning', 'top', 'right', 2000)
          console.error(error)
        })
      } else {
        this.$router.push('/exercise')
      }
    },
    async createQuestionExercise(exerciseID) {
      // console.log('create question exercise: ', this.lstOldQuestionAdded, this.lstQuestionAdded)
      if (this.lstOldQuestionAdded !== null && this.lstOldQuestionAdded.length > 0) {
        for (let f = 0; f < this.lstOldQuestionAdded.length; f++) {
          let variables = {
            object: [{
              exercise_id: exerciseID,
              question_id: parseInt(this.lstOldQuestionAdded[f].id),
              created_by: this.$store.getters.user,
              updated_by: this.$store.getters.user
            }]
          }
          await this.$apollo.mutate({
            mutation: gql(graphql.CREATE_QUESTION_EXERCISE),
            variables: variables
          }).catch((error) => {
            this.loader.hide()
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0)
            }
            console.error(error)
          })
        }
      }
    },
    async createExerciseGrade(exerciseID, isDone = false) {
      if (this.gradeID !== null && this.gradeID.length > 0) {
        for (let f = 0; f < this.gradeID.length; f++) {
          let variables = {
            object: [{
              exercise_id: exerciseID,
              grade_id: parseInt(this.gradeID[f]),
              created_by: this.$store.getters.user,
              updated_by: this.$store.getters.user
            }]
          }
          await this.$apollo.mutate({
            mutation: gql(graphql.CREATE_EXERCISE_GRADE),
            variables: variables
          }).catch((error) => {
            this.loader.hide()
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0)
            }
            console.error(error)
          })
        }
        if (isDone) {
          this.loader.hide()
          this.showNotification('Tạo bài tập thành công', 'success', 'top', 'right', 2000)
          this.$router.push('/exercise')
        }
      }
    },
    // TODO:
    // Khi duyệt học sinh vào lớp thì assign bài tập cho học sinh đó.
    // Check 2 TH: duyệt manual từng học sinh; duyệt 1 loạt học sinh vào nhiều lớp trong pop-up.
    async createExerciseUser(exerciseID) {
      // console.log('creat exercise user: ', this.lstClassAdded)
      if (this.lstClassAdded !== null && this.lstClassAdded.length > 0) {
        for (let c = 0; c < this.lstClassAdded.length; c++) {
          // Thêm bài tập chia sẻ vào lớp
          let lstShareEx = []
          if (this.lstClassAdded[c].exercise_ids === null) lstShareEx.push(parseInt(exerciseID))
          else {
            lstShareEx = this.lstClassAdded[c].exercise_ids.map(Number) // convert element string to number
            if (!lstShareEx.includes(parseInt(exerciseID))) {
              lstShareEx.push(parseInt(exerciseID))
            }
          }
          await this.$apollo.mutate({
            mutation: gql(graphql.UPDATE_CLASSES2),
            variables: {
              where: {
                id: {_eq: this.lstClassAdded[c].id}
              },
              changes: {
                exercise_ids: lstShareEx
              }
            }
          }).catch((error) => {
            this.loader.hide()
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0)
            }
            console.error(error)
          })
          // Gán bài tập cho user
          await this.$apollo.query({
            query: gql(graphql.GET_PC_USER_JOIN_STUDENT),
            variables: {
              where: {
                classes_id: {'_eq': this.lstClassAdded[c].id},
                is_delete: {'_eq': false},
                status: {'_eq': 2}
              },
              order_by: {
                created_at: 'asc'
              }
            }
          }).then(async (res) => {
            if (res.data !== null && res.data.pc_user.length > 0) {
              // LỚP HỌC CÓ HỌC SINH
              let lstStudents = res.data.pc_user
              for (let i = 0; i < lstStudents.length; i++) {
                await this.$apollo.mutate({
                  mutation: gql(graphql.CREATE_EXERCISE_USER),
                  variables: {
                    object: [{
                      exercise_id: exerciseID,
                      user_id: lstStudents[i].user_id,
                      created_by: this.$store.getters.user,
                      updated_by: this.$store.getters.user
                    }]
                  }
                }).catch((error) => {
                  this.loader.hide()
                  if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                    this.$router.go(0)
                  }
                  console.error(error)
                })
              }
            }
          }).catch((error) => {
            this.loader.hide()
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0)
            }
            console.error(error)
          })
        }
        this.loader.hide()
        this.showNotification('Tạo bài tập thành công', 'success', 'top', 'right', 2000)
        this.$router.push('/exercise')
      }
    }
  },
  apollo: {
    categExercise: {
      query() {
        // console.log(graphql.GET_CATEGORY_EXERCISE_FILTER(this.filter + '}', null, null))
        return gql(graphql.GET_CATEGORY_EXERCISE_FILTER(this.filter + '}', this.orderBy, null, null))
      },
      update: data => {
        return data.category_exercise
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error.message)
      }
    },
    categQuestion: {
      query() {
        // console.log(graphql.GET_CATEGORY_QUESTION_FILTER(this.filter + '}', this.offset, this.limit))
        return gql(graphql.GET_CATEGORY_QUESTION_FILTER(this.filter + '}', null, null))
      },
      update: data => {
        return data.category_question
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error.message)
      }
    },
    subjects: {
      query: gql(graphql.GET_SUBJECT_USER),
      fetchPolicy: 'no-cache',
      variables() {
        let variables = {
          where: {
            is_delete: {'_eq': false},
            user_id: {'_eq': this.$store.getters.user},
            status: {'_eq': 2}
          },
          orderBy: {created_at: 'asc'}
        }
        return variables
      },
      update: data => {
        if (data.subject_user.length > 0) {
          let lstSubjects = []
          for (let i = 0; i < data.subject_user.length; i++) {
            lstSubjects.push(data.subject_user[i].subject)
          }
          return lstSubjects
        }
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      }
    },
    grades: {
      query: gql(graphql.GET_GRADES),
      update: data => {
        for (let i = 0; i < data.grades.length; i++) {
          data.grades[i].text = data.grades[i].name
        }
        return data.grades
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error.message)
      }
    },
    questions: {
      query: gql(graphql.GET_QUESTION),
      fetchPolicy: 'no-cache',
      variables() {
        let variables = {
          uid: this.$store.getters.user,
          // limit: 10,
          order_by: {id: 'asc'},
          is_complete: true
        }
        variables = Object.assign(variables, {subject_id: this.filtersubject})
        if (this.parentFilter.level.length > 0) variables = Object.assign(variables, {levels: this.parentFilter.level})
        if (this.parentFilter.categories.length > 0) variables = Object.assign(variables, {categ_ids: this.parentFilter.categories})
        // console.log(variables)
        return variables
      },
      update: data => {
        for (let i = 0; i < data.question.length; i++) {
          data.question[i].stt = i + 1
          data.question[i].customName = '[ID: ' + data.question[i].id + '] ' + data.question[i].content_plain_text
          data.question[i].name = '<span>[ID: ' + data.question[i].id + ']</span> ' + data.question[i].content_plain_text
          let gradeIDs = []
          for (let j = 0; j < data.question[i].question_grade.length; j++) {
            gradeIDs[gradeIDs.length] = data.question[i].question_grade[j].grade.id
          }
          data.question[i].grade_ids = gradeIDs
        }
        // console.log(data.question)
        return data.question
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select2-container--default {
  .custom-container-exgrades {
    border-radius: 10px !important;
  }
}
.exercise-add-content {
  .exercise-add-body {
    .col-md-header {
      margin-bottom: 10px;
    }
    .header {
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      color: #5F6468;
      display: inline-block;
    }
    .col-md-name {
      .form-group {
        margin-top: 0;
        label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
        input, select {background-color: white;}
      }
    }
    .lv-question {
      padding-left: 7.5px;
      .form-group {
        label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
        margin-top: 0;
        input, select {background-color: white;}
      }
      .box-btn-question-search {
        .btn-question-search {
          width: 100%;
          height: 48px;
          background: #FFD311;
          color:black;
          text-transform: none;
          font-size: 14px;
          font-family: 'adobe-clean', sans-serif;
          border: 1px solid #FFD311;
          border-radius: 5px;
          box-shadow: none;
          margin-top: 20px;
          margin-bottom: 0;
        }
      }
    }
    // .select2-container {
    //   .selection {
    //     .custom-container-exgrades {
    //       &.select2-selection--multiple {
    //         border-radius: 10px !important;
    //       }
    //     }
    //   }
    // }
    .categ-question {
      padding-right: 7.5px;
      .form-group {
        label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
        margin-top: 0;
        input, select {background-color: white;}
      }
    }
    .list-questions {
      .title {font-size: 17px; color:#9F6A28; text-transform: uppercase; font-weight: bold;}
      .card-question {
        border-radius: 10px;
        margin-top: 8px;
        margin-bottom: 16px;
        .card-content-question {
          padding-bottom: 5px;
        }
        .card-table-question {
          padding-top: 5px;
        }
        .line {
          width: 100%; 
          text-align: center; 
          border-bottom: 2px solid #00000029;
          box-shadow: 0px 2px 2px #00000029;
          line-height: 0.1em;
          // margin-bottom: 10px;
        }
      }
    }
    .col-checkbox {
      .box-save {
        .box-item-footer {
          display: inline-flex;
          &.title {
            color: #9F6A28;
            text-transform: uppercase;
            font-size: 17px;
            font-weight: bold;
            position: relative;
            top: -5px;
            margin-right: 25px;
          }
        }
        .card-save {
          border-radius: 10px;
          margin-top: 0px;
          margin-bottom: 16px;
          .card-content-save {
            .opacity {
              display: block;
              position: absolute;
              width: 100%;
              height: 100%;
              opacity: 0.5;
              background: white;
              z-index: 1;
              left: 0;
              right: 0;
              top: 0;
            }
            .box-left {padding-left: 30px;}
            .row-amount-honey {
              .form-group {margin-top: 0; margin-bottom: 0;
                .form-control {margin-bottom: 0;}
              }
              label {color: #333333; font-weight: bold;}
            }
            .row-share-class {
              .form-group {margin-top: 0;
                .form-control {margin-bottom: 0;}
              }
            }
            .row-class {
              .box-item-attach{border-top: 1px solid #EAEAEA !important;border-left: 1px solid #EAEAEA !important; border-right: 1px solid #EAEAEA !important;padding: 5px 10px !important; }
              .box-item-attach:last-child{border-bottom: 1px solid #EAEAEA !important;}
              .box-item-attach label{width: 100%; display:block; color:#000;}
              .box-item-attach .fa-paperclip{transform: rotate(90deg); }
              .box-item-attach img{ width: 16px; height: 16px;}
              .box-item-attach span{padding-left: 10px;}
              .box-item-attach .remove{float:right; display:block; z-index: 100; font-size: 20px;}
            }
          }
        }
      }
    }
    .total-time {
      .form-group {
        .without_ampm::-webkit-datetime-edit-ampm-field {
          display: none;
        }
        margin-top: 0;
        label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
        input {background-color: white;}
        // input[type=time]::-webkit-clear-button {
        //   -webkit-appearance: none;
        //   -moz-appearance: none;
        //   -o-appearance: none;
        //   -ms-appearance:none;
        //   appearance: none;
        //   margin: -10px; 
        // }
        // input[type=time]::-webkit-inner-spin-button,
        // input[type=time]::-webkit-outer-spin-button {
        //   -webkit-appearance: none;
        //   -moz-appearance: none;
        //   -o-appearance: none;
        //   -ms-appearance:none;
        //   appearance: none;
        //   margin: 0px; 
        // }
      }
    }
    .col-checkbox {
      margin-top: 0px;
      .button-handle {
        .btn{text-align: left; font-size: 15px;letter-spacing: 0px;color: #333333; padding: 12px 30px; text-transform: inherit;}
        .btn-active{background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px;border: 0 none;}
        .btn-active:nth-child(2) {margin: 0 20px;}
        .btn-rest{border: 0 none; background: transparent; box-shadow: none;}
        .btn-active:hover,.btn-active:active, .btn-active:focus{background: #FFD311 0% 0% no-repeat padding-box; color:#333;box-shadow: none;}
        .btn-rest:hover, .btn-rest:active, .btn-rest:focus{background: transparent;color: #333;box-shadow: none;}
      }
      .item-checkbox{
        display:inline-flex; 
        justify-content: center;
        align-items: center; 
        padding: 7px 0;
        span {margin-left: 8px; font-size: 15px; color: #343A40;}
        input{display:none;}
        input + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box_outline@2x.png") no-repeat center center;height: 24px;width: 24px;display:inline-block; background-size: cover; margin: 0;}
        input:checked + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box@2x.png") no-repeat center center;height: 24px;width: 24px;display:inline-block;background-size: cover;}
      }
    }
  }
}
@media (max-width: 414px) {
  .exercise-add-content {
    .exercise-add-body {
      .lv-question {padding-left: 15px;
        &.col-xs-6 {padding-left: 4px;}
        &.col-xs-5 {padding-left: 0px;}
      }
      .categ-question {padding-right: 15px;
        &.col-xs-6 {padding-right: 4px;}
        &.col-xs-7 {padding-right: 8px;}
      }
      .card-table-question {
        padding: 15px 20px !important;
        .card-lst-question {
          padding: 0;
          .row-header{border: 1px solid #E0E0E0;border-top: 0;background: #FAFAFA 0% 0% no-repeat padding-box; 
            .label-header{
              display: inline-block; line-height: 30px;width: 30%;font-weight: bold;text-align: right; padding-right: 10px;
            }
            .field-header{padding: 5px 10px; display: inline-block; width: 70%; background: #EAEAEA 0% 0% no-repeat padding-box;
              input, select{width: 100%;border-radius: 10px; padding: 3px 10px; background: #fff;border: 1px solid #B4B4B4; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;}
            }
            &:first-child{border-top: 1px solid #E0E0E0;border-radius: 10px; overflow: hidden;}
            &.last{border-bottom-left-radius: 10px !important;border-bottom-right-radius: 10px !important;overflow: hidden;}
          }
          .list-item{margin-top: 15px;
            .row-item{background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; padding: 8px 8px;margin-bottom: 10px;
              &:first-child{margin-bottom: 10px;}
              &:last-child {margin-bottom: 15px;}
              .row-data{
                .label-header{display: inline-block;text-align: left; padding-right: 8px; color: #969FAD;}
                .row-value{padding-bottom: 8px; display: inline-block;
                  &.title{font-size: 15px; font-weight: bold; margin-bottom: 15px;display: block;}
                  &.link{text-decoration: underline; color:#554BC1;}
                  select{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 6px;width: 100%;}
                  small{margin-right: 10px; float: left;
                    &:last-child{margin-right: 0;}
                    img{width: 16px;height: 16px;}
                  }
                  img.img{border-radius: 50%;width: 30px; height: 30px;}
                }
                .board-info{ width: 100%; display: inline-flex; height: 60px; overflow: hidden; text-overflow: ellipsis; margin-bottom: 8px;
                  span{font-size: 15px; font-weight: bold; display: block; color: #9F6A28;}
                }
                .filter-item {
                  span {
                    padding: 4px 8px; 
                    background: #F2F2F2; 
                    border-radius: 10px; 
                    color: #969FAD; 
                    box-shadow: 0px 1px 3px #00000029; 
                    margin: 0 8px 8px 0;
                    cursor: pointer;
                    display: inline-block;
                    &.checked {
                      background: #219AFF; 
                      color: white;
                    }
                  }
                }
                .action-buttons {
                  text-align: right;
                  // margin-bottom: 8px;
                  .list-action {
                    small{width: 16px; height: 16px; margin-right: 16px; display: inline-block;
                      &.support {margin-right: 0px;}
                      img{max-width: 100%; height: auto; cursor: pointer;}
                      .fas {cursor: pointer; vertical-align: text-bottom;}
                    }
                  }
                }
              }
            }
          }
        }
      }
      .col-checkbox {
        .card-save {
          .card-content-save {
            .item-checkbox{
              input + label{width: 40px;}
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// add.vue?23d0680a